<template>
  <nav class="account-wallet-nav" aria-label="账户与提现快捷入口">
    <span class="account-wallet-nav__label">快捷入口</span>
    <router-link
      v-for="link in visibleLinks"
      :key="link.to"
      :to="link.to"
      class="account-wallet-nav__link"
      :class="{ 'account-wallet-nav__link--active': isActive(link.to) }"
    >
      {{ link.label }}
    </router-link>
  </nav>
</template>

<script>
export const ACCOUNT_WALLET_LINKS = [
  { to: '/my', label: '我的' },
  { to: '/real-name-verification', label: '实名认证' },
  { to: '/withdraw/apply', label: '提现申请' },
  { to: '/referral/partner-apply', label: '申请合伙人' },
  { to: '/creator/income', label: '创作者收入' },
  { to: '/transactions', label: '账单明细' }
]

export default {
  name: 'AccountWalletNav',
  props: {
    links: {
      type: Array,
      default: () => ACCOUNT_WALLET_LINKS
    },
    hideCurrent: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    visibleLinks() {
      if (!this.hideCurrent) return this.links
      return this.links.filter((link) => !this.isActive(link.to))
    }
  },
  methods: {
    isActive(path) {
      return this.$route.path === path
    }
  }
}
</script>

<style scoped>
.account-wallet-nav {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 12px;
  margin-bottom: 16px;
  padding: 10px 12px;
  background: #f5f7fa;
  border-radius: 8px;
  border: 1px solid #ebeef5;
}

.account-wallet-nav__label {
  font-size: 13px;
  color: #909399;
  font-weight: 600;
}

.account-wallet-nav__link {
  font-size: 13px;
  color: #409eff;
  text-decoration: none;
  padding: 4px 10px;
  border-radius: 6px;
  background: #fff;
  border: 1px solid #dcdfe6;
}

.account-wallet-nav__link:hover {
  color: #337ecc;
  border-color: #409eff;
}

.account-wallet-nav__link--active {
  color: #fff;
  background: #409eff;
  border-color: #409eff;
  font-weight: 600;
}
</style>
